import { ArrowRight } from "lucide-react";
import { briefPreviewText } from "../lib/briefPreview";
import styles from "../preview.module.scss";

interface BriefPreviewCardProps {
  html?: string;
  onOpen: () => void;
}

export function BriefPreviewCard({ html, onOpen }: BriefPreviewCardProps) {
  const previewHtml = briefPreviewText(html);

  const hasContent = Boolean(briefPreviewText(html));

  return (
    <div className={styles.previewSection}>
      <div className={styles.previewHeader}>
        <label className={styles.previewLabel}>Creator brief</label>
        <span className={styles.previewHint}>Short preview</span>
      </div>
      <button type="button" onClick={onOpen} className={styles.previewCard}>
        {hasContent ? (
          <div
            className={styles.previewHtml}
            dangerouslySetInnerHTML={{ __html: previewHtml }}
          />
        ) : (
          <p className={styles.previewEmpty}>No brief content yet.</p>
        )}
        <span className={styles.openFull}>
          Open full brief
          <ArrowRight size={13} />
        </span>
      </button>
    </div>
  );
}
